import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-mr-md" }
const _hoisted_2 = { class: "text-subtitle1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-images q-mr-xs" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Album:", -1)
const _hoisted_5 = { class: "flex justify-end items-center" }
const _hoisted_6 = { class: "on-left" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Last Saved: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_humanize_time = _resolveComponent("humanize-time")!
  const _component_download_btn = _resolveComponent("download-btn")!
  const _component_bar_x_scrollable = _resolveComponent("bar-x-scrollable")!

  return (_openBlock(), _createBlock(_component_bar_x_scrollable, { class: "report-toolbar q-py-sm q-px-lg justify-between" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.report.name), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_humanize_time, {
            time: _ctx.report.lastModified
          }, null, 8, ["time"])
        ]),
        _createVNode(_component_download_btn, {
          "report-id": _ctx.report.id,
          flat: ""
        }, null, 8, ["report-id"])
      ])
    ]),
    _: 1
  }))
}